module.exports = __webpack_public_path__ + "0fec362e23dc39cecdba625444e97e3b.svg";